module.exports = __webpack_public_path__ + "img/RCT01.3e8bf6cf.svg";